<template>
  <button
    :disabled="isDisabled"
    :class="btnClasses"
    :style="styleObject"
    @click="onClick"
    @mouseenter="updateHoverState(true)"
    @mouseleave="updateHoverState(false)"
  >
    <slot />
  </button>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    isWide: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return{ hoverState : false}
  },
  computed: {
    ...mapGetters('config', ['buttonColor', 'buttonTextColor']),
    btnClasses() {
      return {
        'o-button': true,
        'is-wide': this.isWide,
        'is-active': this.isActive
      }
    },
    styleObject() {
      if (!this.isActive) {
        return {
          border: '1px solid' + this.buttonColor
        }
      } else if (this.isActive && !this.hoverState) {
        return {
          backgroundColor: this.buttonColor,
          color: this.buttonTextColor,
          border: '1px solid' + this.buttonColor
        }
      } else {
        return {
          backgroundColor: this.buttonColor+'b3',
          border: '1px solid' + this.buttonColor+'b3',
          color: this.buttonTextColor
        }
      }
    }
  },

  methods: {
    onClick() {
      this.$emit('click')
    },
    updateHoverState(val) {
      this.hoverState = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// client/components/ObjButton.vue